/** Server totalDisp: 9999 = unlimited availability. */
export function isPurchasableByTotalDisp(totalDisp?: number): boolean {
    const value = totalDisp != null ? totalDisp : 0;
    return value === 9999 || value > 0;
}

export function filterPurchasableStyles<T extends { totalDisp?: number }>(styles: T[]): T[] {
    return styles.filter((style) => isPurchasableByTotalDisp(style.totalDisp));
}
